var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 12c0 6.42-5.205 11.625-11.625 11.625S.375 18.42.375 12 5.58.375 12 .375 23.625 5.58 23.625 12m-12.97 6.155L19.28 9.53a.75.75 0 0 0 0-1.06l-1.06-1.06a.75.75 0 0 0-1.061 0l-7.034 7.033-3.284-3.284a.75.75 0 0 0-1.06 0l-1.061 1.06a.75.75 0 0 0 0 1.061l4.875 4.875a.75.75 0 0 0 1.06 0"
  })));
};
export default SvgCheckCircle;